import { motion } from "framer-motion";
import { fadeUp } from "./animations";

export default function CourseIntro() {
  return (
    <section className="bg-[#f6f6f6] py-20 sm:py-24">
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="
          mx-auto
          max-w-7xl
          px-5
          sm:px-8
          lg:px-10
        "
      >
        <div className="max-w-3xl">
          <p
            className="
              text-xs
              font-bold
              uppercase
              tracking-[0.2em]
              text-[#55aef3]
            "
          >
            Courses at WE3X
          </p>

          <h2
            className="
              merriweather
              mt-5
              flex
              flex-col
              gap-4
              text-3xl
              font-black
              tracking-[-0.04em]
              sm:text-4xl
              lg:text-[52px]
            "
          >
            <span>Learn by doing,</span>
            <span className="text-neutral-400">not just by watching.</span>
          </h2>

          <p
            className="
              mt-6
              max-w-2xl
              text-[16px]
              leading-8
              text-neutral-600
            "
          >
            Every WE3X program is designed around practical learning,
            guided projects and skills that can be applied to real-world work.
          </p>
        </div>
      </motion.div>
    </section>
  );
}
